// extracted by mini-css-extract-plugin
export default {"UserInfoBarOuterContainer":"companyTitleBar_UserInfoBarOuterContainer__NMARH","userInfoContainer":"companyTitleBar_userInfoContainer__RJ-fi"};